import axios from "axios";
import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const iuran = {
   namespaced: true,
   state: {
      data: [],
      totalRecords: 0,
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getAll({ commit, rootState }) {
         rootState.isLoading = true;
         await axios
            .get(`${API_URL}iuran`, {
               headers: authHeader(),
            })

            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getAllRemote({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}iuran/remote`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
                  return response.data;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async insert({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}iuran`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async delete({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .delete(`${API_URL}iuran/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data.rows;
         state.totalRecords = data.totalRecords;
      },
   },
};
